@if (data?.media) {
  <sd-banner [media]="data?.media" />
}

@if (data?.description) {
  <div class="c__content">
    <sd-html [html]="data.description" innerClass="is-wysiwyg" />
  </div>
}

@if (data?.links) {
  <sd-link
    [link]="data.links[0]"
    (clicked)="onClick()"
    [tabIndex]="tabIndex"
    customClass="is-full-area"
  />
}
